<template>
  <div>
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <app-cells>
        <div class="date-picker-wrapper">
          <VueCtkDateTimePicker
            id="date_picker_balance"
            class="custom-date-time-picker custom-date-time-picker--range"
            v-model="filter_dates"
            :custom-shortcuts="custom_shortcuts"
            @is-hidden="onIsHiddenPicker"
            format="YYYY-MM-DD"
            formatted="ll"
            label="Select dates"
            color="#77b017"
            button-color="#77b017"
            overlay
            no-header
            no-label
            locale="en"
            range
            noClearButton
          />
          <div v-if="date_picker_error" class="date-picker-wrapper__error">Choose an end date</div>
        </div>
        <app-input
          @input.native="onTransactionSearch"
          v-model="filter_search"
          class="input--300"
          type="search"
          placeholder="Search"
          name="search"
        />
      </app-cells>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader }"
      >
        <template #h__user><div class="table-default__left">Waiter</div></template>
        <template #created="{ row }">{{ dateFormat(row.created_at) }}</template>
        <template #user="{ row }"><div class="table-default__left">{{ row.user }}</div></template>
        <template #number="{ row }">{{ row.number || '-' }}</template>
        <template #amount="{ row }">{{ amountFormat(row.order_amount) }} $</template>
        <template #tips="{ row }">{{ row.waiter_tip ? `${amountFormat(row.waiter_tip.amount)} $` : '-' }}</template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPagination"
            v-if="pagination.pages > 1"
            v-model="pagination.page"
            :page-count="pagination.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination.count" :count="table.items.length" :page="pagination.page" />
      </app-cells>
    </template>
  </div>
</template>

<script>
import { getHotelManagementRestaurantReceipts } from '@/http'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import { format, parseISO } from 'date-fns'
import debounce from 'lodash/debounce'

export default {
  name: 'HotelManagementRestaurantReceiptsManagement',
  components: {VueCtkDateTimePicker},
  data() {
    return {
      page_loaded: false,
      filter_dates: {},
      date_picker_error: false,
      filter_search: '',
      custom_shortcuts: [
        { key: 'last3Days', label: 'Last 3 days', value: 3 },
        { key: 'last7Days', label: 'Last 7 days', value: 7 },
        { key: 'last14Days', label: 'Last 14 days', value: 14 },
      ],
      table: {
        items: [],
        columns: [
          'id',
          'created',
          'user',
          'number',
          'table',
          'amount',
        ],
        options: {
          headings: {
            'id': 'ID',
            'created': 'Created',
            'user': 'Waiter',
            'number': 'Number',
            'table': 'Table',
            'amount': 'Amount',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_preloader: false,
    }
  },
  created() {
    this.fetchItems()
  },
  methods: {
    async fetchItems() {
      this.table_preloader = true
      const response = await getHotelManagementRestaurantReceipts({
        page: this.pagination.page,
        page_size: 20,
        search: this.filter_search,
        created_at__gte: this.filter_dates?.start,
        created_at__lte: this.filter_dates?.end,
        section: 'Management'
      })
      this.table.items = response.data.results
      this.pagination.pages = response.data.pages
      this.pagination.count = response.data.count
      this.table_preloader = false
      this.page_loaded = true
    },
    onClickPagination(page) {
      this.pagination.page = page
      this.fetchItems()
    },
    onChangeFilter() {
      this.filter_search = ''
      this.pagination.page = 1
      this.fetchItems()
    },
    onIsHiddenPicker() {
      if (this.filter_dates?.start && this.filter_dates?.end) {
        this.date_picker_error = false
        this.fetchItems()
      } else this.date_picker_error = true
    },
    amountFormat(amount) {
      return new Intl.NumberFormat('ru-RU').format(amount)
    },
    dateFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy HH:mm') : '-'
    },
    onTransactionSearch() {
      this.searchTransaction(this)
    },
    searchTransaction: debounce(vm => {
      vm.pagination_rooms.page = 1
      vm.pagination_walk.page = 1
      vm.fetchTables()
    }, 350),
  }
}
</script>
